var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入设备序列号" },
            model: {
              value: _vm.searchData.sn,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "sn", $$v)
              },
              expression: "searchData.sn"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入当前版本" },
            model: {
              value: _vm.searchData.currentVersion,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "currentVersion", $$v)
              },
              expression: "searchData.currentVersion"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入目标版本" },
            model: {
              value: _vm.searchData.targetVersion,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "targetVersion", $$v)
              },
              expression: "searchData.targetVersion"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择状态"
              },
              model: {
                value: _vm.searchData.status,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "status", $$v)
                },
                expression: "searchData.status"
              }
            },
            [
              _c("el-option", { attrs: { label: "请选择状态", value: "" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "开始升级", value: "0" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "升级成功", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "升级失败", value: "2" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n      上报时间：\n      "),
          _c("el-date-picker", {
            attrs: {
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期"
            },
            model: {
              value: _vm.searchData.reportTime,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "reportTime", $$v)
              },
              expression: "searchData.reportTime"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n        显示/隐藏列\n        "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }